export enum ProfileType {
    All = 'ALL',
    Person = 'PERSON',
    Pet = 'PET'
}

export const getProfileTypeFriendlyName = (type: ProfileType) => {
    switch (type) {
        case ProfileType.Person:
            return 'Person';
        case ProfileType.Pet:
            return 'Pet';
    }
}
